<template>
    <el-dialog class="el-dialogs" :title="title" :close-on-click-modal="false" width="500px"
               :visible.sync="visible">
        <el-tree
                style="height:400px;overflow-y: auto"
                ref="tree"
                :data="allDataList"
                show-checkbox
                node-key="id"
                :check-strictly="true"
                default-expand-all
                :props="defaultProps">
        </el-tree>
        <div slot="footer">
            <el-button size="small" type="primary" @click="doSubmit()">确定</el-button>
            <el-button size="small" @click="visible = false">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "allGrouping",
    data() {
        return {
            title: '资源分组',
            visible: false,
            allDataList: [],//所有数据
            defaultProps: {
                children: 'children',
                label: 'indexName'
            },
        }
    },

    methods: {
        init(allDataList, selectData) {
            this.allDataList = allDataList
            this.visible = true
            this.$nextTick(()=>{
                selectData.forEach(item => {
                    this.$refs.tree.setChecked(item.id, true)
                })
            })
        },

        doSubmit() {
            let selectData = this.$refs.tree.getCheckedNodes()
            selectData.forEach(item => {
                this.$set(item, 'grouping', true)
                this.$set(item, 'name', item.groupingName)
            })
            this.$emit('selectGrouping',selectData)
            this.visible = false
        },
    },
}
</script>

<style scoped>

</style>